import ControlButton from '../controlButton.js';

import * as btnStyles from '../btn.module.scss';

import config from '../../../gameConfig.js';

const { ROUNDS_NUMBER } = config;

export default class NextBtn extends ControlButton {
  constructor() {
    super({ text: 'NEXT' });

    this.addClasses(btnStyles.btnHidden);
    window.addEventListener('mouseup', this.handleNextRound.bind(this));
    window.addEventListener('changeinput', this.handleChangeInput.bind(this));
  }

  /**
   * Sets the state's round property.
   * @returns {void}
   * @private
   */
  handleNextRound() {
    if (this.isPressed && !this.state.block) {
      this.state.round += 1;
    }
  }

  /**
   * Handles changes in the state's input property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @private
   */
  handleChangeInput(e) {
    const { input } = e.detail;
    const { round, sequence, sequenceIndex } = this.state;

    const isRoundComplete =
      input.length > 0 && sequenceIndex === sequence.length;

    const isRoundLast = round === ROUNDS_NUMBER;

    if (isRoundComplete && !isRoundLast) {
      this.removeClasses(btnStyles.btnHidden);
    } else {
      this.addClasses(btnStyles.btnHidden);
    }
  }
}
